/**
  * 深色背景用 横向柱状图
  * @param unit 单位
  * @param dataArr [{name:'',value:0}]数据合集
*/
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let data = paramObj.dataArr
  let getArrByKey = (data, k) => {
    let key = k || "value";
    let res = [];
    if (data) {
      data.forEach(function (t) {
        res.push(t[key]);
      });
    }
    return res;
  };
  let getSymbolData = (data) => {
    let arr = [];
    for (var i = 0; i < data.length; i++) {
      arr.push({
        value: data[i].value,
        symbolPosition: "end",
      });
    }
    return arr;
  };
  let option = {
    grid: {
      top: "20px",
      left: "10px",
      right: "15px",
      bottom: "20px",
    },
    tooltip: {
      trigger: "axis",
      borderColor: "#62FFFF",
      formatter:function (params) {
        let result = '';
        params.forEach(function (item) {
          result = item.name +
            " : " +
            dealBigNum(item.value) +
            paramObj.unit
        });
        return result;
      },
      axisPointer: {
        type: "line",
        lineStyle: {
          color: "rgba(237,237,237,.1)",
          type: "solid",
          width: 20,
        },
      },
    },
    xAxis: {
      show: false,
    },
    yAxis: [
      {
        inverse: true,
        data: getArrByKey(data, "name"),
        axisLine: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
      },
      {
        type: "category",
        inverse: true,
        axisTick: "none",
        axisLine: "none",
        show: true,
        axisLabel: {
          align: "right",
          padding: [0, 8, 0, 0],
          verticalAlign: "bottom",
          lineHeight: 26,
          formatter: function (value, index) {
            return `{a|${dealBigNum(value)}${paramObj.unit}}`;
          },
          rich: {
            a: {
              color: "#868B99",
              fontSize: "12",
              padding: [0, 0, 2, 0],
            },
          },
        },
        data: getArrByKey(data, "value"),
      },
    ],
    series: [
      {
        type: "pictorialBar",
        symbolSize: [0, 0],
        data: getSymbolData(data),
      },
      {
        name: "条",
        type: "bar",
        showBackground: true,
        borderRadius: 10,
        yAxisIndex: 0,
        data: data,
        barWidth: 10,
        itemStyle: {
          color: {
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: "#0FA8CB",
              },
              {
                offset: 1,
                color: "#3BE9CF",
              },
            ],
            globalCoord: false, 
          },
          borderRadius: [0, 20, 20, 0],
        },
        label: {
          color: "#CED0D6",
          show: true,
          position: [0, "-20px"],
          fontSize: 12,
          formatter: function (a, b) {
            return a.name;
          },
        },
      },
    ],
  };

  return option
  
}